import { gql } from '@apollo/client';

export default gql`
  mutation markNotificationAsRead($id: ID!) {
    markNotificationAsRead(input: { id: $id }) {
      notification {
        id
        readAt
      }
    }
  }
`;
